<div class="container-fluid" *ngIf="!isEditar && !isAgregar">
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
        <div class="page-title-box">
            <div class="page-title-right">
              <a href="#/panel-admin" class="btn btn-primary">
                Volver
              </a>
            </div>
            <h3 class="page-title">Usuarios | Estudiantes</h3>
        </div>
    </div>
  </div>
  <!-- end page title -->

  <div class="row" style="overflow-x: scroll;">
    <div class="col-12">
      <div class="card" style="border-color: white;">
        <div class="card-body" style="margin-bottom: 150px;">
          <!-- Invoice Logo-->
          <div class="row">
            <div class="col-md-5">
              <label for="estadol" class="col-form-label">Busqueda</label>
              <input
                class="form-control"
                type="text"
                id="buscar"
                placeholder="Buscar estudiante..."
                [(ngModel)]="searchTerm"
                (input)="buscarAccionFormativa()"
              >
            </div>
            <div class="col-md-5">
              <label for="estadol" class="col-form-label">Estado</label>
              <select class="form-select" id="estado" name="estado" (change)="consulta_combos()">
                <option *ngFor="let ed of estado" [value]="ed.id_estado" [selected]="ed.id_estado == sel_edo ? true : false">
                  {{ed.nombre}}
                </option>
              </select>
            </div>
            <div class="col-md-2">
              <a class="btn btn-primary" style="margin-top: 37px;" (click)="agregar()">
                Agregar
              </a>
            </div>

          </div>

          <hr class="text-dark">
          <div class="row">
            <div class="col-12">
              <table class="table">
                <thead>
                  <tr class="table-primary">
                    <th scope="col">N°</th>
                    <th scope="col">Cedula</th>
                    <th scope="col">Nombre(s) y Apellido(s)</th>
                    <th scope="col">Rol</th>
                    <th scope="col">Estados</th>
                    <th scope="col">Estatus</th>
                    <th scope="col">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let r of filteredResultado; let i = index">
                    <th scope="row">{{i+1}}</th>
                    <td>{{r.identificacion}}</td>
                    <td>{{r.nombre_full}}</td>
                    <td>{{r.rol}}</td>
                    <td>{{r.estado}}</td>
                    <td>{{r.estatus}}</td>
                    <td>
                      <input class="form-check-input" type="checkbox" id={{r.id_estudiante}} value={{r.id_estudiante}} name="perfil"  [checked]="r.valido === true" >
                      &nbsp;&nbsp;&nbsp;
                      <a style="cursor: pointer;" class="btn btn-sm btn-primary" (click)="editar(r.id_estudiante, r.nombre_full, r.identificacion)">Editar</a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div> <!-- end card-body-->
      </div> <!-- end card -->
    </div> <!-- end col-->
  </div>



</div>

<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje"></app-modal>


<app-agregar *ngIf="isAgregar" (vuelve)="volver($event)"></app-agregar>


<app-editar *ngIf="isEditar"
[id_estudiante]="id_estudiante"
[nombre_participante]="nombre_participante"
(vuelve)="volver($event)"
></app-editar>
